import { CdkStepperNext, CdkStepperPrevious } from '@angular/cdk/stepper';
import { Directive, HostBinding, Input } from '@angular/core';

/** Button that moves to the next step in a stepper workflow. */
@Directive({
  selector: 'button[nStepperNext]',
})
export class NStepperNextDirective extends CdkStepperNext {
  @HostBinding('class') readonly class = 'n-stepper-next';
  @HostBinding('type') @Input() override type = 'submit';
}

/** Button that moves to the previous step in a stepper workflow. */
@Directive({
  selector: 'button[nStepperPrevious]',
})
export class NStepperPreviousDirective extends CdkStepperPrevious {
  @HostBinding('class') class = 'n-stepper-previous';
  @HostBinding('type') @Input() override type = 'button';
}
